/**
 * G-94 — is this search box holding a scanned code or a typed name?
 *
 * The inventory search box takes both: G-83 made the Scan button type the code
 * into it precisely so a scanned code and a typed one take the same path. When
 * neither finds anything, the offer to create the item has to guess which
 * field the text belongs in, and guessing wrong is cheap but annoying — a
 * product name in the barcode box, or a barcode as the item's name.
 *
 * The rule is deliberately narrow: digits only, and at least eight of them.
 * Real codes here are EAN-8 and EAN-13 (`8059824474353`, the Ming candles of
 * G-61), and a product name is never all digits. A short number — "40", a
 * quantity someone typed — falls through to the name, which is recoverable in
 * one keystroke, rather than being asserted as a barcode.
 *
 * It does NOT validate a checksum. This decides which field to prefill, not
 * whether a code is real; `Item.barcode` is deliberately not unique (G-61) and
 * the server is the authority on what it accepts.
 */
export function looksLikeBarcode(value: string): boolean {
  const trimmed = value.trim();
  return trimmed.length >= 8 && /^\d+$/.test(trimmed);
}
